import React from 'react'
import { useSelector } from 'react-redux'

import { legendConfigs } from '../data/legendTierConfigs'
const LegendTier = () => {
  const theme = useSelector((state) => state.mapStyle.darkMode ? 'dark' : 'light')

  return (
    <div
      className={`fixed sm:bottom-8 bottom-2 left-1/2 transform -translate-x-1/2 w-[320px] h-16 shadow-xl flex flex-row rounded-full p-2    ${theme === 'dark' ? 'bg-zinc-700' : 'bg-white'} `}
    >
      {Object.values(legendConfigs).map((config, index) => (
        <div
          key={index}
          className={`flex flex-col justify-center align-center items-start ml-8 w-auto h-12 rounded-lg px-2 ${
            index === 0 ? 'rounded-l-lg' : ''
          } ${index === Object.values(legendConfigs).length - 1 ? 'rounded-r-lg' : ''}`}
        >
          <div>
            <p
              className={`text-[9px] mb-1 text-center  ${theme === 'dark' ? 'text-slate-200 font-bold' : 'text-zinc-700 font-bold'} `}
              dangerouslySetInnerHTML={{ __html: config.title }}
            />
          </div>
          <div
            className=':not-first:child- ml-2'
            style={{
              width: '30px',
              height: '30px',
              backgroundImage: config.image ? `url(${config.image})` : null,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundColor: config.image ? null : config.color,
              borderRadius: '5px'
            }}
          />
        </div>
      ))}
    </div>
  )
}

export default LegendTier
